module.exports = __webpack_public_path__ + "img/profile_settings_icon.2b81f5cd.svg";